'use client';

import { useMemo } from 'react';
import Accordion from 'components/gruenland/atoms/accordion';
import { useProductList } from '../../context';

type Props = { children?: React.ReactNode; attribute: string };

const Facet = ({ children, attribute }: Props) => {
  const { activeRefinements, facetsConfiguration } = useProductList();
  const count = useMemo(
    () => activeRefinements.filter((x) => x.attribute === attribute).length,
    [activeRefinements, attribute],
  );

  return (
    <Accordion
      className="border-b border-neutral-400 px-4 py-5"
      buttonClassName="text-[14px]"
      closedSectionTitle={
        <div className="flex gap-2 align-middle font-semibold uppercase">
          {facetsConfiguration[attribute].label}
          {count > 0 && (
            <span className="size-[18px] items-center justify-center rounded-full bg-accent-green-light text-[12px] font-medium">
              {count}
            </span>
          )}
        </div>
      }
      variant="arrow"
      iconClassName="stroke-secondary-black w-5 stroke-2"
    >
      <div className="pt-7">{children}</div>
    </Accordion>
  );
};

export default Facet;
